<template>
  <van-field
    :model-value="displayLabel"
    :name="name"
    :label="label"
    :placeholder="placeholder"
    :disabled="disabled"
    :required="required"
    :rules="rules"
    is-link
    readonly
    clickable
    @click="!disabled && (showPicker = true)"
  />
  <van-popup v-model:show="showPicker" position="bottom">
    <div style="height: 80vh; overflow-y: auto;">
      <van-search
        v-if="searchable"
        v-model="searchQuery"
        :placeholder="searchPlaceholder"
        show-action
        @cancel="showPicker = false"
      />
      <van-cell
        v-for="item in filteredColumns"
        :key="item[columnNames.value]"
        :title="item[columnNames.text]"
        @click="selectItem(item)"
      />
    </div>
  </van-popup>
</template>

<script setup>
import { ref, computed } from 'vue'

const props = defineProps({
  modelValue: {
    type: [String, Number],
    default: ''
  },
  name: {
    type: String,
    required: true
  },
  label: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: '请选择'
  },
  columns: {
    type: Array,
    default: () => []
  },
  columnNames: {
    type: Object,
    default: () => ({ text: 'dictLabel', value: 'dictValue' })
  },
  disabled: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  rules: {
    type: Array,
    default: () => []
  },
  searchable: {
    type: Boolean,
    default: true
  },
  searchField: {
    type: String,
    default: ''
  },
  searchPlaceholder: {
    type: String,
    default: '搜索'
  }
})

const emit = defineEmits(['update:modelValue', 'change', 'confirm'])

const showPicker = ref(false)
const searchQuery = ref('')

// 根据当前值查找对应的 label
const displayLabel = computed(() => {
  if (!props.modelValue || !props.columns.length) return ''
  const item = props.columns.find(i => String(i[props.columnNames.value]) === String(props.modelValue))
  return item ? item[props.columnNames.text] : ''
})

// 过滤后的列表
const filteredColumns = computed(() => {
  if (!searchQuery.value) return props.columns
  const field = props.searchField || props.columnNames.text
  return props.columns.filter(item => 
    item[field]?.includes(searchQuery.value)
  )
})

function selectItem(item) {
  const value = item[props.columnNames.value]
  const label = item[props.columnNames.text]
  
  emit('update:modelValue', value)
  emit('confirm', {
    value,
    label,
    selected: item
  })
  emit('change', {
    value,
    label,
    selected: item
  })
  
  showPicker.value = false
  searchQuery.value = ''
}
</script>
